
// import React, { useState, useEffect } from "react";
// import { ThumbsUp, MessageCircle, Users, Plus, X, Send, Filter, Download } from "lucide-react";
// import { databases, DATABASE_ID, POSTS_COLLECTION_ID } from "./config/appwrite";
// import { storage, STORAGE_BUCKET_ID } from "./config/appwrite";
// import { ID } from "appwrite";
// import client from "./config/appwrite";

// const categories = [
//   "Government Services",
//   "Brands & Products",
//   "Social Issues",
//   "Infrastructure",
//   "Environment",
//   "Healthcare",
//   "Education",
//   "Other",
// ];

// export default function IssuesPlatform() {
//   const [posts, setPosts] = useState([]);
//   const [showNewPost, setShowNewPost] = useState(false);
//   const [selectedPost, setSelectedPost] = useState(null);
//   const [filterCategory, setFilterCategory] = useState("All");
//   const [preview, setPreview] = useState(null);
//   const [commentText, setCommentText] = useState("");
//   const [collabName, setCollabName] = useState("");
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [originalButtonText, setOriginalButtonText] = useState("Post Issue");

//   const [newPost, setNewPost] = useState({
//     title: "",
//     description: "",
//     category: "Government Services",
//     author: "",
//     location: "",
//     image: "",
//     phone: "",
//     email: "",
//   });

//   const [generatedPDF, setGeneratedPDF] = useState(null);

//   // Parse string comments into array for UI
//   const parseComments = (commentString) => {
//     if (typeof commentString !== 'string' || !commentString) return [];
//     return commentString.split(";").filter(Boolean).map((c, index) => {
//       const [text, author, createdAt] = c.split("|");
//       return { 
//         id: index + 1, 
//         text: text || "", 
//         author: author || "Anonymous User", 
//         createdAt: createdAt || new Date().toISOString() 
//       };
//     });
//   };

//   // Parse string collaborators into array for UI
//   const parseCollaborators = (collabString) => {
//     if (typeof collabString !== 'string' || !collabString) return [];
//     return collabString.split(",").filter(Boolean).map(name => name.trim());
//   };

//   // Load posts from Appwrite
//   useEffect(() => {
//     const fetchPosts = async () => {
//       try {
//         const res = await databases.listDocuments(DATABASE_ID, POSTS_COLLECTION_ID);
//         const safePosts = res.documents.map((p) => ({
//           ...p,
//           comments: parseComments(p.comments || ""),
//           collaborators: parseCollaborators(p.collaborators || ""),
//           image: p.image || "",
//           upvotes: p.upvotes || 0,
//           hasUpvoted: false,
//           status: p.status || "pending",
//           pdf_generated: p.pdf_generated || false,
//           authorities_sent: p.authorities_sent || 0,
//           total_authorities: p.total_authorities || 0,
//         }));
//         setPosts(safePosts);
//       } catch (err) {
//         console.error("❌ Failed to fetch posts:", err);
//         // Don't alert on development to avoid spam
//         if (process.env.NODE_ENV === 'production') {
//           alert("Failed to load posts. Please try again.");
//         }
//       }
//     };
//     fetchPosts();
//   }, []);

//   // Enhanced Groq call using YOUR original structure
//   const callGroqRewrite = async (text) => {
//     try {
//       const GROQ_KEY = "${GROQ_AI_API_KEY}"; // Your original format - replace with actual key in production
//       if (!GROQ_KEY || GROQ_KEY === "${GROQ_AI_API_KEY}") {
//         console.warn("⚠️ GROQ_API_KEY not configured, using fallback authorities");
//         return {
//           rewritten: `Formal complaint regarding ${newPost.title}. The issue described involves ${newPost.category.toLowerCase()} and requires immediate attention from relevant authorities. The problem is located at ${newPost.location} and affects public welfare and safety. Detailed investigation and remedial action is requested under applicable laws.`,
//           location: newPost.location || "",
//           authorities: [
//             {
//               name: "Local Municipal Authority",
//               twitter: "@municipality",
//               email: "complaints@municipal.gov.in",
//               address: `${newPost.location || "City Municipal Corporation Office"}`
//             }
//           ]
//         };
//       }

//       const payload = {
//         model: "llama-3.3-70b-versatile",
//         messages: [
//           {
//             role: "system",
//             content: `You are a legal-drafting assistant. Using the inputs {DATE},${newPost.author},${newPost.location},${newPost.email || 'N/A'},${newPost.category},${newPost.title},${newPost.incidentDate || 'Recent'},${newPost.location},${text},${newPost.image ? 'Photographic evidence attached' : 'No visual evidence'},${getLegalProvisions(newPost.category)},${newPost.relief || 'Immediate action and investigation'}, generate one formal legal complaint document in English with headings: To, Subject, COMPLAINANT, BRIEF FACTS, PARTIES, EVIDENCE ATTACHED, LEGAL PROVISIONS, CONSEQUENCES, RELIEF SOUGHT, DECLARATION, signature block, and enclosures. Output only the complaint text.

// Base the authorities on common ones for categories like Government Services (e.g., Municipal Corporation, @municipality), Brands (e.g., Consumer Forum, @brandhandle). If unsure, suggest generic like @localgov.

// For the JSON response, ensure you return:
// {
//   "rewritten": "The formal complaint text",
//   "location": "Extracted location from text",
//   "authorities": [
//     {
//       "name": "Authority Name",
//       "twitter": "@handle",
//       "email": "official@email.com",
//       "address": "Office Address"
//     }
//   ]
// }`,
//           },
//           { 
//             role: "user", 
//             content: `Category: ${newPost.category}\nTitle: ${newPost.title}\nLocation: ${newPost.location}\nDescription: ${text}` 
//           },
//         ],
//         max_tokens: 800,
//         temperature: 0.2,
//       };

//       const res = await fetch("https://api.groq.com/openai/v1/chat/completions", {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${GROQ_KEY}`,
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(payload),
//       });

//       if (!res.ok) {
//         const txt = await res.text();
//         console.error("Groq error:", res.status, txt);
//         throw new Error("Groq API error - using fallback template");
//       }

//       const data = await res.json();
//       let response = data?.choices?.[0]?.message?.content || "";

//       // Clean response and attempt JSON parsing
//       response = response.replace(/``````/g, "").trim();

//       let parsedResponse;
//       try {
//         // If response contains JSON, parse it
//         const jsonStart = response.indexOf('{');
//         const jsonEnd = response.lastIndexOf('}') + 1;
//         if (jsonStart !== -1 && jsonEnd !== -1) {
//           const jsonString = response.substring(jsonStart, jsonEnd);
//           parsedResponse = JSON.parse(jsonString);
//         }
//       } catch (jsonErr) {
//         console.warn("JSON parsing failed, using raw response as fallback:", jsonErr);
//       }

//       // Fallback authorities based on category
//       const fallbackAuthorities = [
//         {
//           name: newPost.category === "Government Services" ? "Municipal Corporation" :
//                 newPost.category === "Brands & Products" ? "District Consumer Forum" :
//                 newPost.category === "Environment" ? "State Pollution Control Board" :
//                 "Local Government Authority",
//           twitter: `@${newPost.category.toLowerCase().replace(/ & /g, '').replace(/ /g, '')}gov`,
//           email: `complaints@${newPost.category.toLowerCase().replace(/ & /g, '').replace(/ /g, '')}.gov.in`,
//           address: `${newPost.location}, India`
//         }
//       ];

//       return {
//         rewritten: parsedResponse?.rewritten || response || text,
//         location: parsedResponse?.location || newPost.location || "",
//         authorities: parsedResponse?.authorities?.length > 0 ? parsedResponse.authorities : fallbackAuthorities
//       };

//     } catch (e) {
//       console.error("callGroqRewrite error:", e);
      
//       // Return fallback with your original template style
//       return {
//         rewritten: `To: The Competent Authority\n\nSubject: Formal Complaint Regarding ${newPost.title}\n\nRespected Sir/Madam,\n\nI, ${newPost.author}, resident of ${newPost.location}, do hereby lodge this formal complaint concerning the following matter:\n\nBRIEF FACTS:\nThe issue involves ${newPost.category.toLowerCase()} and has been causing significant inconvenience to the public. The problem is located at ${newPost.location} and requires immediate attention.\n\nPARTIES INVOLVED:\nThe concerned authorities responsible for this matter.\n\nEVIDENCE ATTACHED:\n${newPost.image ? 'Photographic evidence' : 'Detailed description'}\n\nLEGAL PROVISIONS:\n${getLegalProvisions(newPost.category).substring(0, 200)}\n\nRELIEF SOUGHT:\nImmediate investigation and remedial action.\n\nDECLARATION:\nThe contents are true to the best of my knowledge.\n\n${newPost.author}\n${newPost.location}\nDate: ${new Date().toLocaleDateString('en-IN')}`,
//         location: newPost.location || "",
//         authorities: [
//           {
//             name: "Local Municipal Authority",
//             twitter: "@municipality",
//             email: "complaints@municipal.gov.in",
//             address: `${newPost.location || "City Municipal Office"}`
//           }
//         ]
//       };
//     }
//   };

//   // Dynamic legal provisions by category (your original structure)
//   const getLegalProvisions = (category) => {
//     const provisions = {
//       "Government Services": "Section 133 CrPC (Public Nuisance), Municipal Corporation Act, Right to Services Act 2015, Consumer Protection Act 1986",
//       "Brands & Products": "Consumer Protection Act 2019, Sale of Goods Act 1930, Legal Metrology Act 2009, Drugs and Cosmetics Act 1940",
//       "Social Issues": "Article 21 Constitution (Right to Life), Protection of Civil Rights Act 1955, POCSO Act 2012, Domestic Violence Act 2005",
//       "Infrastructure": "National Highways Act 1956, Indian Roads Congress Specifications, Disaster Management Act 2005, Local Municipal Laws",
//       "Environment": "Environment Protection Act 1986, Water Act 1974, Air Act 1981, Forest Conservation Act 1980, Wildlife Protection Act 1972",
//       "Healthcare": "Clinical Establishments Act 2010, Indian Medical Council Regulations 2002, Epidemic Diseases Act 1897, Mental Healthcare Act 2017",
//       "Education": "RTE Act 2009, UGC Act 1956, AICTE Act 1987, National Education Policy 2020, Protection of Children Act",
//       "Other": "Relevant Central/State Acts, Municipal Regulations, Constitutional Provisions, Local Government Rules"
//     };
//     return provisions[category] || provisions["Other"];
//   };

//   // Generalized backend call for tweet, PDF gen, email
//   const postToBackend = async (action, payload) => {
//     try {
//       const controller = new AbortController();
//       const timeoutId = setTimeout(() => controller.abort(), 30000); // 30s timeout

//       const res = await fetch("https://arush1234sharma-querio-backend.hf.space/process", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ action, ...payload }),
//         signal: controller.signal
//       });

//       clearTimeout(timeoutId);

//       if (!res.ok) {
//         const errorText = await res.text();
//         throw new Error(`Backend ${action} failed: ${res.status} - ${errorText}`);
//       }
      
//       return await res.json();
//     } catch (err) {
//       if (err.name === 'AbortError') {
//         return { ok: false, error: "Request timeout - please try again" };
//       }
//       console.error(`${action} error:`, err);
//       return { ok: false, error: err.message || "Network error" };
//     }
//   };

//   // Handle image upload with preview
//   const handleImageUpload = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     // Validate file
//     if (!file.type.startsWith('image/')) {
//       alert("Please select a valid image file (JPG, PNG, GIF)");
//       return;
//     }

//     if (file.size > 5 * 1024 * 1024) { // 5MB
//       alert("Image size must be less than 5MB");
//       return;
//     }

//     try {
//       // Create preview
//       const previewUrl = URL.createObjectURL(file);
//       setPreview(previewUrl);

//       // Upload to Appwrite
//       const uploaded = await storage.createFile(STORAGE_BUCKET_ID, ID.unique(), file);
//       console.log("✅ Image uploaded:", uploaded.$id);

//       const publicUrl = storage.getFileView(STORAGE_BUCKET_ID, uploaded.$id);
//       console.log("🖼️ Public URL:", publicUrl);

//       setNewPost(prev => ({ ...prev, image: publicUrl.toString() }));
      
//       // Cleanup old preview if exists
//       if (preview) {
//         URL.revokeObjectURL(preview);
//       }
//     } catch (err) {
//       console.error("❌ Image upload failed:", err);
//       alert("Failed to upload image. Please try again.");
//       if (preview) {
//         URL.revokeObjectURL(preview);
//         setPreview(null);
//       }
//     }
//   };

//   // Handle upvote and persist to Appwrite
//   const handleUpvote = async (postId) => {
//     try {
//       const post = posts.find(p => p.$id === postId);
//       if (!post) return;

//       const currentUpvotes = post.upvotes || 0;
//       const newUpvotes = post.hasUpvoted ? currentUpvotes - 1 : currentUpvotes + 1;
      
//       await databases.updateDocument(DATABASE_ID, POSTS_COLLECTION_ID, postId, {
//         upvotes: newUpvotes,
//       });

//       setPosts(prev => 
//         prev.map(p =>
//           p.$id === postId
//             ? { ...p, upvotes: newUpvotes, hasUpvoted: !p.hasUpvoted }
//             : p
//         )
//       );
//     } catch (err) {
//       console.error("❌ Upvote failed:", err);
//       alert("Failed to update upvote. Please try again.");
//     }
//   };

//   // Handle comment addition and persist to Appwrite
//   const handleAddComment = async (postId) => {
//     if (!commentText.trim() || isSubmitting) return;

//     const newComment = {
//       text: commentText.trim().slice(0, 500),
//       author: newPost.author || "Anonymous User",
//       createdAt: new Date().toISOString(),
//     };

//     try {
//       const post = posts.find(p => p.$id === postId);
//       if (!post) return;

//       const currentComments = parseComments(post.comments);
//       const updatedComments = [...currentComments, newComment];
      
//       // Limit comments to prevent overflow (last 50)
//       const limitedComments = updatedComments.slice(-50);
//       const commentString = limitedComments
//         .map(c => `${c.text}|${c.author}|${c.createdAt}`)
//         .join(";");

//       await databases.updateDocument(DATABASE_ID, POSTS_COLLECTION_ID, postId, {
//         comments: commentString,
//       });

//       setPosts(prev =>
//         prev.map(p =>
//           p.$id === postId
//             ? { ...p, comments: parseComments(commentString) }
//             : p
//         )
//       );
      
//       setCommentText("");
//       console.log("✅ Comment added successfully");
//     } catch (err) {
//       console.error("❌ Comment failed:", err);
//       alert("Failed to add comment. Please try again.");
//     }
//   };

//   // Handle collaborator addition and persist to Appwrite
//   const handleAddCollaborator = async (postId) => {
//     if (!collabName.trim() || isSubmitting) return;

//     try {
//       const post = posts.find(p => p.$id === postId);
//       if (!post) return;

//       const currentCollaborators = parseCollaborators(post.collaborators);
//       const cleanName = collabName.trim();
      
//       if (currentCollaborators.includes(cleanName)) {
//         alert("You're already a collaborator on this issue!");
//         return;
//       }

//       const updatedCollaborators = [...currentCollaborators, cleanName];
//       // Limit to 30 collaborators to prevent overflow
//       const limitedCollaborators = updatedCollaborators.slice(0, 30);
//       const collabString = limitedCollaborators.join(",");

//       await databases.updateDocument(DATABASE_ID, POSTS_COLLECTION_ID, postId, {
//         collaborators: collabString,
//       });

//       setPosts(prev =>
//         prev.map(p =>
//           p.$id === postId
//             ? { ...p, collaborators: parseCollaborators(collabString) }
//             : p
//         )
//       );
      
//       setCollabName("");
//       console.log(`✅ ${cleanName} added as collaborator`);
//     } catch (err) {
//       console.error("❌ Collaborator addition failed:", err);
//       alert("Failed to add collaborator. Please try again.");
//     }
//   };

//   // Create post with tweet, PDF, email flow - ENHANCED WITH YOUR GROQ STRUCTURE
//   const handleCreatePost = async () => {
//     // Validation
//     if (!newPost.title?.trim()) {
//       alert("Please enter a title for your issue");
//       return;
//     }
    
//     if (!newPost.description?.trim()) {
//       alert("Please describe your issue in detail");
//       return;
//     }
    
//     if (!newPost.author?.trim()) {
//       alert("Please enter your name");
//       return;
//     }
    
//     if (!newPost.location?.trim()) {
//       alert("Please specify the location of the issue");
//       return;
//     }

//     if (newPost.description.length < 20) {
//       alert("Please provide more details about your issue (minimum 20 characters)");
//       return;
//     }

//     // Set loading state
//     setIsSubmitting(true);
//     setOriginalButtonText("Processing...");
    
//     let tweetSuccess = false;
//     let tweetId = null;
//     let pdfSuccess = false;
//     let emailSuccessCount = 0; // FIXED: Properly declared variable
//     let emailTotal = 0;

//     try {
//       // 1) Call Groq with YOUR original structure
//       console.log("🤖 Calling Groq API for legal formatting...");
//       const groqRes = await callGroqRewrite(newPost.description);
//       const { rewritten, location: extractedLocation, authorities } = groqRes;
      
//       const finalLocation = extractedLocation || newPost.location;
//       console.log("📄 Groq response:", {
//         rewritten: rewritten.substring(0, 100) + "...",
//         location: finalLocation,
//         authorities: authorities.map(a => a.name).join(", ")
//       });

//       // 2) Prepare tweet
//       const tweetTags = authorities
//         .slice(0, 3) // Limit to 3 authorities
//         .map(auth => auth.twitter ? `@${auth.twitter.replace('@', '')}` : '')
//         .filter(Boolean)
//         .join(' ');

//       const tweetText = `${newPost.title}

// "${rewritten.substring(0, 150)}..."

// 📍 ${finalLocation}
// ${newPost.category}

// #CitizenComplaint #PublicIssue ${tweetTags}`;

//       console.log("🐦 Tweet content prepared:", tweetText.length, "characters");

//       // 3) Auto-tweet
//       try {
//         const tweetRes = await postToBackend("tweet", { 
//           text: tweetText,
//           image_url: newPost.image || null,
//           category: newPost.category
//         });
        
//         if (tweetRes.ok) {
//           tweetSuccess = true;
//           tweetId = tweetRes.tweet_id || tweetRes.tweet_url || null;
//           console.log("✅ Tweet posted:", tweetId);
//         } else {
//           console.warn("Tweet failed (non-blocking):", tweetRes.error);
//         }
//       } catch (tweetErr) {
//         console.warn("Tweet error (continuing anyway):", tweetErr.message);
//       }

//       // 4) Generate PDF with your original template style
//       console.log("📋 Generating legal PDF...");
      
//       const currentDate = new Date().toLocaleDateString('en-IN', { 
//         day: '2-digit', month: 'long', year: 'numeric' 
//       });

//       // Format authorities for letter
//       const formattedAuthorities = authorities.map(auth => 
//         `${auth.name}\n${auth.address || finalLocation}\n${auth.email ? `Email: ${auth.email}` : ''}`
//       ).join('\n\n');

//       // Your original legal template structure
//       const legalPrompt = `Generate a formal legal complaint document with the following EXACT structure and formatting:

// [TOP RIGHT CORNER]
// Date: ${currentDate}

// [LEFT ALIGNED]
// To,
// ${formattedAuthorities}

// Subject: Formal Complaint Regarding ${newPost.title}

// Respected Sir/Madam,

// [BODY - Use formal legal language]
// I, ${newPost.author}, resident of ${finalLocation}, hereby lodge this formal complaint regarding the following matter:

// 1. BACKGROUND AND FACTS:
// ${rewritten}

// 2. NATURE OF GRIEVANCE:
// The issue constitutes a violation of public welfare standards under ${newPost.category}. This involves negligence in [specific service/infrastructure] leading to public inconvenience and safety concerns.

// 3. IMPACT AND CONSEQUENCES:
// The matter affects community safety, public health, and essential services. Continued inaction may result in escalation of the problem and legal liabilities.

// 4. EVIDENCE:
// ${newPost.image ? 'Photographic evidence attached showing the exact issue location and condition.' : 'Detailed observations and community impact documentation.'}

// 5. LEGAL PROVISIONS:
// ${getLegalProvisions(newPost.category)}

// 6. RELIEF SOUGHT:
// I respectfully request the following actions:
// a) Immediate investigation within 7 days
// b) Remedial action within 15 days  
// c) Regular status updates via email/SMS
// d) Compensation for damages if applicable
// e) Preventive measures to avoid recurrence

// 7. CONCLUSION:
// I trust your office will treat this matter with utmost urgency. I remain available for clarification or personal hearing as required.

// Thanking you in anticipation of prompt action.

// Yours faithfully,

// ${newPost.author}
// ${finalLocation}
// ${newPost.phone ? `Phone: ${newPost.phone}` : ''}
// ${newPost.email ? `Email: ${newPost.email}` : ''}

// [FOOTER]
// Enclosures:
// 1. ${newPost.image ? 'Photographic evidence' : 'Issue description'}
// 2. Supporting documents (if applicable)
// 3. Copy for records

// Note: Please acknowledge receipt within 3 working days and provide reference number for tracking.`;

//       // Backend call for PDF
//       const pdfRes = await postToBackend("generate_pdf", {
//         title: `Legal-Complaint-${newPost.title.replace(/[^a-zA-Z0-9]/g, '-')} (${Date.now()})`,
//         content: legalPrompt,
//         authorities: JSON.stringify(authorities),
//         category: newPost.category,
//         complainant: newPost.author,
//         location: finalLocation,
//         has_image: !!newPost.image,
//         format: 'A4'
//       });

//       console.log("PDF Response:", pdfRes);

//       if (pdfRes.ok && pdfRes.pdf_base64) {
//         pdfSuccess = true;
        
//         // Store PDF
//         setGeneratedPDF({
//           base64: pdfRes.pdf_base64,
//           filename: pdfRes.filename || `Legal-Complaint-${newPost.title.replace(/[^a-zA-Z0-9]/g, '-')}.pdf`
//         });

//         // Auto-download
//         const link = document.createElement('a');
//         link.href = `data:application/pdf;base64,${pdfRes.pdf_base64}`;
//         link.download = pdfRes.filename || `Legal-Complaint-${Date.now()}.pdf`;
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
        
//         console.log("✅ PDF downloaded:", pdfRes.filename);
//       } else {
//         console.warn("PDF generation failed:", pdfRes?.error);
//       }

//       // 5) Email authorities
//       if (pdfSuccess && pdfRes.pdf_base64 && authorities.length > 0) {
//         console.log("📧 Emailing authorities...");
//         emailTotal = authorities.length;

//         for (const authority of authorities) {
//           if (!authority.email || !authority.email.includes('@')) {
//             console.warn(`Skipping ${authority.name}: No valid email`);
//             continue;
//           }

//           try {
//             const emailRes = await postToBackend("send_email", {
//               to: authority.email,
//               subject: `Formal Legal Complaint: ${newPost.title}`,
//               body: `Dear ${authority.name},

// A formal legal complaint has been filed against your department/organization regarding:

// 📋 Title: ${newPost.title}
// 📍 Location: ${finalLocation}  
// 👤 Complainant: ${newPost.author}
// 📂 Category: ${newPost.category}

// Key Issues:
// ${rewritten.substring(0, 300)}...

// Legal Basis: ${getLegalProvisions(newPost.category).substring(0, 150)}

// Please find the complete formal complaint attached.

// This matter requires your immediate attention and action within 15 days as per applicable laws.

// For tracking: Complaint ID Q${Date.now().toString().slice(-6)}

// Regards,
// Querio Platform
// Citizen Grievance Portal`,
//               attachment: pdfRes.pdf_base64,
//               filename: pdfRes.filename,
//               category: newPost.category,
//             });

//             if (emailRes.ok) {
//               emailSuccessCount++;
//               console.log(`✅ Email sent to ${authority.name} (${authority.email})`);
//             } else {
//               console.warn(`Email failed for ${authority.name}:`, emailRes.error);
//             }
//           } catch (emailErr) {
//             console.error(`Email error for ${authority.name}:`, emailErr);
//           }
//         }
//       }

//       console.log(`📧 Emails: ${emailSuccessCount}/${emailTotal} successful`);

//       // 6) Save to Appwrite
//       console.log("💾 Saving to database...");
      
//       const docData = {
//         title: newPost.title,
//         description: rewritten.substring(0, 1000), // Truncated for listing
//         full_description: rewritten,
//         category: newPost.category,
//         author: newPost.author,
//         location: finalLocation,
//         phone: newPost.phone || null,
//         email: newPost.email || null,
//         image: newPost.image || null,
//         upvotes: 0,
//         comments: "",
//         collaborators: "",
//         status: "pending",
//         pdf_generated: pdfSuccess,
//         pdf_filename: pdfSuccess ? pdfRes.filename : null,
//         authorities_sent: emailSuccessCount,
//         total_authorities: emailTotal,
//         tweet_id: tweetId || null,
//         ai_enhanced: true,
//         created_via: "queria_platform_groq",
//       };

//       const appwriteRes = await databases.createDocument(
//         DATABASE_ID,
//         POSTS_COLLECTION_ID,
//         ID.unique(),
//         docData
//       );

//       console.log("✅ Saved to Appwrite:", appwriteRes.$id);

//       // 7) Update UI
//       const newPostObj = {
//         ...appwriteRes,
//         comments: [],
//         collaborators: [],
//         hasUpvoted: false,
//       };

//       setPosts([newPostObj, ...posts]);

//       // 8) Reset form
//       setShowNewPost(false);
//       setNewPost({
//         title: "", description: "", category: "Government Services",
//         author: "", location: "", image: "", phone: "", email: ""
//       });
//       setPreview(null);
//       setGeneratedPDF(null);
//       setIsSubmitting(false);
//       setOriginalButtonText("Post Issue");

//       // 9) Success message
//       const successParts = [
//         "✅ Your complaint has been successfully processed!",
//         "",
//         `📝 Reference ID: Q${Date.now().toString().slice(-6)}`,
//         `📱 Tweeted: ${tweetSuccess ? '✅ Yes' : '⚠️ Skipped'}`,
//         `📄 Legal PDF: ${pdfSuccess ? '✅ Generated & Downloaded' : '⚠️ Failed'}`,
//         `📧 Authorities: ${emailSuccessCount}/${emailTotal} notified`,
//         `💾 Saved to dashboard for tracking`
//       ];

//       alert(successParts.join('\n'));

//     } catch (err) {
//       console.error("❌ Post creation error:", err);
      
//       setIsSubmitting(false);
//       setOriginalButtonText("Post Issue");
      
//       alert(`Error processing complaint: ${err.message}\n\nPlease check your connection and try again.`);
//     }
//   };

//   // Filtered posts
//   const filteredPosts = filterCategory === "All" ? posts : posts.filter(p => p.category === filterCategory);

//   return (
//     <div className="min-h-screen bg-gray-900">
//       <div className="relative min-h-screen overflow-hidden">
//         <div className="lumin-landing-bg"></div>
        
//         {/* Header */}
//         <header className="glass-effect shadow-md relative z-10">
//           <div className="max-w-7xl mx-auto px-4 py-6">
//             <div className="flex items-center justify-between">
//               <div className="text-white">
//                 <h1 className="text-2xl font-bold">RaizeIt</h1>
//                 <p className="text-sm text-indigo-300">AI-Powered Citizen Grievance Portal</p>
//               </div>
//               <button
//                 onClick={() => setShowNewPost(true)}
//                 disabled={isSubmitting}
//                 className={`px-6 py-3 rounded-2xl flex items-center gap-2 font-semibold transition-all ${
//                   isSubmitting 
//                     ? "bg-gray-600 text-gray-300 cursor-not-allowed" 
//                     : "bg-indigo-600 hover:bg-indigo-700 text-white button-gradient shadow-lg"
//                 }`}
//               >
//                 {isSubmitting ? (
//                   <>
//                     <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
//                     Processing...
//                   </>
//                 ) : (
//                   <>
//                     <Plus size={20} />
//                     {originalButtonText}
//                   </>
//                 )}
//               </button>
//             </div>
//           </div>
//         </header>

//         {/* Main Content */}
//         <div className="max-w-7xl mx-auto px-4 py-8 relative z-10">
//           {/* Filter Bar */}
//           <div className="mb-8 glass-effect p-4 rounded-2xl shadow-sm backdrop-blur-sm">
//             <div className="flex items-center gap-3 flex-wrap">
//               <Filter size={20} className="text-indigo-300" />
//               <span className="font-semibold text-white">Filter by Category:</span>
              
//               <button
//                 onClick={() => setFilterCategory("All")}
//                 className={`px-4 py-2 rounded-full text-sm font-medium transition-all m-1 ${
//                   filterCategory === "All"
//                     ? "bg-indigo-600 text-white shadow-md"
//                     : "bg-gray-800/50 text-gray-300 hover:bg-gray-700/50 border border-white/20"
//                 }`}
//               >
//                 All ({posts.length})
//               </button>
              
//               {categories.map(cat => {
//                 const count = posts.filter(p => p.category === cat).length;
//                 return (
//                   <button
//                     key={cat}
//                     onClick={() => setFilterCategory(cat)}
//                     className={`px-4 py-2 rounded-full text-sm font-medium transition-all m-1 ${
//                       filterCategory === cat
//                         ? "bg-indigo-600 text-white shadow-md"
//                         : "bg-gray-800/50 text-gray-300 hover:bg-gray-700/50 border border-white/20"
//                     }`}
//                   >
//                     {cat} ({count})
//                   </button>
//                 );
//               })}
//             </div>
//           </div>

//           {/* Posts Grid */}
//           <div className="grid gap-6">
//             {filteredPosts.length > 0 ? filteredPosts.map(post => (
//               <div key={post.$id} className="glass-effect rounded-3xl shadow-lg hover:shadow-xl transition-all duration-300 p-6 border border-white/10">
//                 <div className="flex items-start justify-between mb-4">
//                   <div className="flex-1">
//                     {/* Category & Status */}
//                     <div className="flex items-center gap-3 mb-3 flex-wrap">
//                       <span className="px-3 py-1 bg-gradient-to-r from-indigo-500 to-purple-600 text-white rounded-full text-sm font-medium">
//                         {post.category}
//                       </span>
                      
//                       <span className="text-indigo-300 text-sm">
//                         {post.createdAt ? Math.floor((new Date() - new Date(post.createdAt)) / (1000 * 60 * 60 * 24)) : 0} days ago
//                       </span>
                      
//                       {post.pdf_generated && (
//                         <span className="px-2 py-1 bg-green-500/20 text-green-300 rounded-full text-xs font-medium border border-green-500/30">
//                           📄 Legal PDF
//                         </span>
//                       )}
                      
//                       {post.status && (
//                         <span className={`px-2 py-1 rounded-full text-xs font-semibold ${
//                           post.status === 'pending' ? 'bg-yellow-500/20 text-yellow-300 border-yellow-500/30' :
//                           post.status === 'in_progress' ? 'bg-blue-500/20 text-blue-300 border-blue-500/30' :
//                           'bg-green-500/20 text-green-300 border-green-500/30'
//                         } border`}>
//                           {post.status.replace('_', ' ').toUpperCase()}
//                         </span>
//                       )}
//                     </div>

//                     {/* Title */}
//                     <h2 className="text-2xl font-bold text-white mb-3 leading-tight">
//                       {post.title}
//                     </h2>

//                     {/* Description */}
//                     <p className="text-gray-300 mb-4 leading-relaxed" style={{display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden'}}>
//                       {post.description || (post.full_description?.substring(0, 200) + "...")}
//                     </p>

//                     {/* Image */}
//                     {post.image && (
//                       <div className="mb-4 rounded-xl overflow-hidden border border-white/10">
//                         <img
//                           src={post.image}
//                           alt="Issue evidence"
//                           className="w-full h-48 object-cover"
//                           onError={(e) => {
//                             console.warn("Image load failed:", post.image);
//                             e.target.style.display = 'none';
//                           }}
//                         />
//                       </div>
//                     )}

//                     {/* Meta Info */}
//                     <div className="space-y-2 mb-4 text-sm">
//                       <div className="flex items-center gap-2 text-indigo-400">
//                         <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
//                           <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
//                         </svg>
//                         <span className="font-medium">{post.location}</span>
//                       </div>

//                       {post.author && (
//                         <div className="flex items-center gap-4 text-gray-400">
//                           <span className="flex items-center gap-1">
//                             <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
//                               <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
//                             </svg>
//                             <span>By {post.author}</span>
//                           </span>
                          
//                           {post.collaborators?.length > 0 && (
//                             <span className="flex items-center gap-1">
//                               <Users className="w-4 h-4 text-green-400" />
//                               <span>{post.collaborators.length} supporters</span>
//                             </span>
//                           )}
                          
//                           {post.authorities_sent > 0 && (
//                             <span className="flex items-center gap-1 text-green-400">
//                               <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
//                                 <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
//                               </svg>
//                               <span>{post.authorities_sent} authorities notified</span>
//                             </span>
//                           )}
//                         </div>
//                       )}
//                     </div>
//                   </div>

//                   {/* Action Buttons */}
//                   <div className="flex items-center gap-4 pt-4 border-t border-white/10">
//                     <button
//                       onClick={() => handleUpvote(post.$id)}
//                       className={`flex items-center gap-2 px-4 py-2 rounded-xl font-medium transition-all ${
//                         post.hasUpvoted
//                           ? "bg-gradient-to-r from-indigo-600 to-purple-600 text-white shadow-lg"
//                           : "bg-white/10 text-gray-300 hover:bg-white/20 hover:text-white border border-white/20"
//                       }`}
//                     >
//                       <ThumbsUp size={16} />
//                       <span>{post.upvotes || 0}</span>
//                     </button>

//                     <button
//                       onClick={() => setSelectedPost(selectedPost === post.$id ? null : post.$id)}
//                       className="flex items-center gap-2 px-4 py-2 rounded-xl bg-white/10 text-gray-300 hover:bg-white/20 hover:text-white border border-white/20 transition-all"
//                     >
//                       <MessageCircle size={16} />
//                       <span>{(post.comments || []).length}</span>
//                     </button>

//                     <button className="flex items-center gap-2 px-4 py-2 rounded-xl bg-white/10 text-gray-300 hover:bg-white/20 hover:text-white border border-white/20 transition-all">
//                       <Users size={16} />
//                       <span>{(post.collaborators || []).length}</span>
//                     </button>

//                     {post.tweet_id && (
//                       <a
//                         href={`https://twitter.com/${post.tweet_id}`}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         className="flex items-center gap-2 px-4 py-2 rounded-xl bg-blue-500/20 text-blue-300 hover:bg-blue-500/30 hover:text-blue-200 border border-blue-500/30 transition-all"
//                       >
//                         🐦 View Tweet
//                       </a>
//                     )}
//                   </div>
//                 </div>

//                 {/* Comments & Collaborators */}
//                 {selectedPost === post.$id && (
//                   <div className="mt-6 space-y-6 border-t border-white/10 pt-6">
//                     {/* Comments Section */}
//                     <div>
//                       <h3 className="font-semibold text-white mb-4 flex items-center gap-2">
//                         <MessageCircle size={20} className="text-indigo-400" />
//                         Comments ({(post.comments || []).length})
//                       </h3>
                      
//                       <div className="space-y-3 mb-4 max-h-40 overflow-y-auto">
//                         {(post.comments || []).map(comment => (
//                           <div key={comment.id} className="bg-white/5 p-3 rounded-xl border border-white/10">
//                             <div className="flex items-center gap-2 mb-1">
//                               <span className="px-2 py-1 bg-indigo-500/20 text-indigo-300 rounded-full text-xs">
//                                 {comment.author}
//                               </span>
//                               <span className="text-xs text-gray-400">
//                                 {comment.createdAt ? Math.floor((new Date() - new Date(comment.createdAt)) / (1000 * 60)) : 0}m ago
//                               </span>
//                             </div>
//                             <p className="text-gray-300 text-sm">{comment.text}</p>
//                           </div>
//                         ))}
//                       </div>
                      
//                       <div className="flex gap-2">
//                         <input
//                           type="text"
//                           value={commentText}
//                           onChange={e => setCommentText(e.target.value)}
//                           placeholder="Add a comment..."
//                           className="flex-1 px-4 py-2 bg-white/10 text-white placeholder-gray-400 border border-white/20 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500"
//                           onKeyPress={e => e.key === "Enter" && handleAddComment(post.$id)}
//                           maxLength={200}
//                           disabled={isSubmitting}
//                         />
//                         <button
//                           onClick={() => handleAddComment(post.$id)}
//                           disabled={!commentText.trim() || isSubmitting}
//                           className="px-4 py-2 bg-indigo-600 text-white rounded-xl hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center gap-2"
//                         >
//                           <Send size={16} />
//                         </button>
//                       </div>
//                     </div>

//                     {/* Collaborators Section */}
//                     <div>
//                       <h3 className="font-semibold text-white mb-4 flex items-center gap-2">
//                         <Users size={20} className="text-green-400" />
//                         Collaborators ({(post.collaborators || []).length})
//                       </h3>
                      
//                       <div className="flex flex-wrap gap-2 mb-4">
//                         {(post.collaborators || []).map((collab, idx) => (
//                           <span key={idx} className="px-3 py-1 bg-green-500/20 text-green-300 rounded-full text-sm border border-green-500/30">
//                             {collab}
//                           </span>
//                         ))}
//                       </div>
                      
//                       <div className="flex gap-2">
//                         <input
//                           type="text"
//                           value={collabName}
//                           onChange={e => setCollabName(e.target.value)}
//                           placeholder="Your name..."
//                           className="flex-1 px-4 py-2 bg-white/10 text-white placeholder-gray-400 border border-white/20 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500"
//                           onKeyPress={e => e.key === "Enter" && handleAddCollaborator(post.$id)}
//                           maxLength={50}
//                           disabled={isSubmitting}
//                         />
//                         <button
//                           onClick={() => handleAddCollaborator(post.$id)}
//                           disabled={!collabName.trim() || isSubmitting}
//                           className="px-4 py-2 bg-green-600 text-white rounded-xl hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center gap-2"
//                         >
//                           <Users size={16} />
//                           Join
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             )) : (
//               <div className="col-span-full text-center py-16">
//                 <div className="text-gray-400 text-xl mb-4">
//                   {filterCategory === "All" ? "No issues yet" : `No ${filterCategory.toLowerCase()} issues found`}
//                 </div>
//                 <p className="text-gray-500 mb-8 max-w-md mx-auto">
//                   Be the first to report a community issue. Your complaint will be professionally formatted and sent to the right authorities.
//                 </p>
//                 <button
//                   onClick={() => setShowNewPost(true)}
//                   disabled={isSubmitting}
//                   className={`px-8 py-3 rounded-2xl font-semibold transition-all ${
//                     isSubmitting
//                       ? "bg-gray-600 text-gray-300 cursor-not-allowed"
//                       : "bg-gradient-to-r from-indigo-600 to-purple-600 text-white hover:shadow-xl transform hover:-translate-y-1"
//                   } flex items-center gap-2 mx-auto`}
//                 >
//                   <Plus size={20} />
//                   {isSubmitting ? "Processing..." : "Report First Issue"}
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>

//         {/* New Post Modal - Enhanced */}
//         {showNewPost && (
//           <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 z-50">
//             <div className="bg-white/95 backdrop-blur-xl rounded-3xl max-w-4xl w-full max-h-[95vh] overflow-hidden shadow-2xl border border-white/20">
//               {/* Header */}
//               <div className="sticky top-0 bg-white z-20 border-b border-gray-200 px-6 py-4">
//                 <div className="flex items-center justify-between">
//                   <div>
//                     <h2 className="text-2xl font-bold text-gray-900">File New Complaint</h2>
//                     <p className="text-gray-600 text-sm mt-1">Your submission will be automatically formatted into a professional legal document</p>
//                   </div>
//                   <button
//                     onClick={() => {
//                       setShowNewPost(false);
//                       setNewPost({title:"",description:"",category:"Government Services",author:"",location:"",image:"",phone:"",email:""});
//                       setPreview(null);
//                     }}
//                     className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-xl transition-colors"
//                   >
//                     <X size={24} />
//                   </button>
//                 </div>
//               </div>

//               {/* Form */}
//               <div className="p-6 overflow-y-auto max-h-[calc(95vh-8rem)]">
//                 <div className="grid md:grid-cols-2 gap-6">
//                   {/* Left Column - Personal Info */}
//                   <div className="space-y-4">
//                     <div className="md:col-span-2">
//                       <label className="block text-sm font-medium text-gray-700 mb-2">
//                         Your Full Name <span className="text-red-500">*</span>
//                       </label>
//                       <input
//                         type="text"
//                         value={newPost.author}
//                         onChange={e => setNewPost({...newPost, author: e.target.value})}
//                         className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent text-black"
//                         placeholder="Enter your full name"
//                         required
//                         disabled={isSubmitting}
//                       />
//                     </div>

//                     <div className="grid grid-cols-2 gap-4">
//                       <div>
//                         <label className="block text-sm font-medium text-gray-700 mb-2">Phone</label>
//                         <input
//                           type="tel"
//                           value={newPost.phone}
//                           onChange={e => setNewPost({...newPost, phone: e.target.value})}
//                           className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent text-black" 
//                           placeholder="+91 98765 43210"
//                           disabled={isSubmitting}
//                         />
//                       </div>
                      
//                       <div>
//                         <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
//                         <input
//                           type="email"
//                           value={newPost.email}
//                           onChange={e => setNewPost({...newPost, email: e.target.value})}
//                           className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent text-black"
//                           placeholder="your.email@example.com"
//                           disabled={isSubmitting}
//                         />
//                       </div>
//                     </div>

//                     <div>
//                       <label className="block text-sm font-medium text-gray-700 mb-2">
//                         Exact Location <span className="text-red-500">*</span>
//                       </label>
//                       <input
//                         type="text"
//                         value={newPost.location}
//                         onChange={e => setNewPost({...newPost, location: e.target.value})}
//                         className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent text-black"
//                         placeholder="House #123, Street Name, Area, City - PINCODE"
//                         required
//                         disabled={isSubmitting}
//                       />
//                       <p className="text-xs text-gray-500 mt-1">Be as specific as possible for accurate authority routing</p>
//                     </div>
//                   </div>

//                   {/* Right Column - Issue Details */}
//                   <div className="space-y-4">
//                     <div>
//                       <label className="block text-sm font-medium text-gray-700 mb-2">
//                         Category <span className="text-red-500">*</span>
//                       </label>
//                       <select
//                         value={newPost.category}
//                         onChange={e => setNewPost({...newPost, category: e.target.value})}
//                         className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent text-black"
//                         disabled={isSubmitting}
//                       >
//                         {categories.map(cat => (
//                           <option key={cat} value={cat}>{cat}</option>
//                         ))}
//                       </select>
//                     </div>

//                     <div>
//                       <label className="block text-sm font-medium text-gray-700 mb-2">
//                         Issue Title <span className="text-red-500">*</span>
//                       </label>
//                       <input
//                         type="text"
//                         value={newPost.title}
//                         onChange={e => setNewPost({...newPost, title: e.target.value})}
//                         className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent text-black"
//                         placeholder="Clear title describing the problem"
//                         required
//                         disabled={isSubmitting}
//                       />
//                     </div>

//                     <div className="md:col-span-2">
//                       <label className="block text-sm font-medium text-gray-700 mb-2">
//                         Description <span className="text-red-500">*</span>
//                       </label>
//                       <textarea
//                         value={newPost.description}
//                         onChange={e => setNewPost({...newPost, description: e.target.value})}
//                         rows={6}
//                         className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent resize-vertical min-h-[120px] text-black"
//                         placeholder="Describe the issue in detail: When it started, who is responsible, how it affects you and others, what you've tried..."
//                         required
//                         disabled={isSubmitting}
//                       />
//                       <div className="mt-2 p-3 bg-blue-50 border border-blue-200 rounded-xl">
//                         <p className="text-sm text-blue-800 mb-2">
//                           <strong>AI Processing:</strong> Our system will automatically:
//                         </p>
//                         <ul className="text-xs text-blue-700 space-y-1 list-disc list-inside">
//                           <li>Convert your text to formal legal language</li>
//                           <li>Identify responsible authorities</li>
//                           <li>Add relevant legal provisions</li>
//                           <li>Generate professional PDF complaint</li>
//                           <li>Email authorities with tracking</li>
//                         </ul>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Image Upload */}
//                 <div className="mt-6">
//                   <label className="block text-sm font-medium text-gray-700 mb-3">
//                     📷 Upload Evidence (Photos help authorities understand the issue)
//                   </label>
//                   <div className="border-2 border-dashed border-gray-300 rounded-2xl p-8 text-center hover:border-indigo-400 transition-colors cursor-pointer">
//                     <input
//                       type="file"
//                       accept="image/*"
//                       onChange={handleImageUpload}
//                       className="hidden"
//                       id="file-upload"
//                       disabled={isSubmitting}
//                     />
//                     <label htmlFor="file-upload" className="cursor-pointer">
//                       <div className="space-y-2">
//                         {preview ? (
//                           <>
//                             <img src={preview} alt="Preview" className="mx-auto max-h-32 rounded-xl object-cover" />
//                             <p className="text-sm font-medium text-gray-700">Image selected ✓</p>
//                             <button
//                               type="button"
//                               onClick={() => {
//                                 setPreview(null);
//                                 setNewPost(prev => ({...prev, image: ""}));
//                                 document.getElementById('file-upload').value = '';
//                               }}
//                               className="text-xs text-red-500 hover:text-red-700"
//                             >
//                               Remove
//                             </button>
//                           </>
//                         ) : (
//                           <>
//                             <div className="w-12 h-12 mx-auto mb-3 bg-gray-100 rounded-xl flex items-center justify-center">
//                               <svg className="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
//                               </svg>
//                             </div>
//                             <p className="text-lg font-medium text-gray-900 mb-1">Upload Photo Evidence</p>
//                             <p className="text-sm text-gray-500">JPG, PNG up to 5MB - Multiple photos help</p>
//                           </>
//                         )}
//                       </div>
//                     </label>
//                   </div>
//                 </div>

//                 {/* Action Buttons */}
//                 <div className="flex gap-4 mt-8 pt-6 border-t border-gray-200">
//                   <button
//                     type="button"
//                     onClick={() => {
//                       setShowNewPost(false);
//                       setNewPost({title:"",description:"",category:"Government Services",author:"",location:"",image:"",phone:"",email:""});
//                       setPreview(null);
//                     }}
//                     disabled={isSubmitting}
//                     className="flex-1 px-6 py-3 border border-gray-300 rounded-xl text-gray-700 font-medium hover:bg-gray-50 transition-colors disabled:opacity-50"
//                   >
//                     Cancel
//                   </button>
                  
//                   <button
//                     type="button"
//                     onClick={handleCreatePost}
//                     disabled={isSubmitting}
//                     className={`flex-1 px-6 py-3 rounded-xl font-semibold shadow-lg transition-all flex items-center justify-center gap-2 ${
//                       isSubmitting
//                         ? "bg-gray-400 text-gray-200 cursor-not-allowed"
//                         : "bg-gradient-to-r from-indigo-600 to-purple-600 text-white hover:shadow-xl hover:-translate-y-0.5"
//                     }`}
//                   >
//                     {isSubmitting ? (
//                       <>
//                         <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
//                         Processing with AI...
//                       </>
//                     ) : (
//                       <>
//                         <Send size={18} />
//                         Submit Legal Complaint
//                       </>
//                     )}
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

































import React, { useState, useEffect } from "react";
import { ThumbsUp, MessageCircle, Users, Plus, X, Send, Filter, Download } from "lucide-react";
import { databases, DATABASE_ID, POSTS_COLLECTION_ID } from "./config/appwrite";
import { storage, STORAGE_BUCKET_ID } from "./config/appwrite";
import { ID } from "appwrite";
import client from "./config/appwrite";
import { auth } from "./auth.jsx";

const categories = [
  "Government Services",
  "Brands & Products",
  "Social Issues",
  "Infrastructure",
  "Environment",
  "Healthcare",
  "Education",
  "Other",
];

// Helper functions for upvote tracking
const hasUserUpvoted = (postId, userEmail) => {
  if (!userEmail) return false;
  const upvotedPosts = JSON.parse(localStorage.getItem(`upvoted_${userEmail}`) || '{}');
  return !!upvotedPosts[postId];
};

const markPostAsUpvoted = (postId, userEmail) => {
  if (!userEmail) return;
  const upvotedPosts = JSON.parse(localStorage.getItem(`upvoted_${userEmail}`) || '{}');
  upvotedPosts[postId] = true;
  localStorage.setItem(`upvoted_${userEmail}`, JSON.stringify(upvotedPosts));
};

const showUpvoteFeedback = (postTitle) => {
  const feedback = document.createElement('div');
  feedback.className = 'fixed top-4 right-4 bg-green-500 text-white px-4 py-2 rounded-lg shadow-lg z-50';
  feedback.innerHTML = `
    <div class="flex items-center gap-2">
      <span>✅</span>
      <span>Upvoted "${postTitle}"</span>
    </div>
  `;
  document.body.appendChild(feedback);
  
  setTimeout(() => {
    if (document.body.contains(feedback)) {
      document.body.removeChild(feedback);
    }
  }, 3000);
};

export default function IssuesPlatform() {
  const [posts, setPosts] = useState([]);
  const [showNewPost, setShowNewPost] = useState(false);
  const [selectedPost, setSelectedPost] = useState(null);
  const [filterCategory, setFilterCategory] = useState("All");
  const [preview, setPreview] = useState(null);
  const [commentText, setCommentText] = useState("");
  const [collabName, setCollabName] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [originalButtonText, setOriginalButtonText] = useState("Post Issue");
  const [currentUser, setCurrentUser] = useState(null);

  const [newPost, setNewPost] = useState({
    title: "",
    description: "",
    category: "Government Services",
    author: "",
    location: "",
    image: "",
    phone: "",
    email: "",
  });

  const [generatedPDF, setGeneratedPDF] = useState(null);

  // Listen for auth state changes
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setCurrentUser(user);
    });
    return () => unsubscribe();
  }, []);

  // Parse string comments into array for UI
  const parseComments = (commentString) => {
    if (typeof commentString !== 'string' || !commentString) return [];
    return commentString.split(";").filter(Boolean).map((c, index) => {
      const [text, author, createdAt] = c.split("|");
      return { 
        id: index + 1, 
        text: text || "", 
        author: author || "Anonymous User", 
        createdAt: createdAt || new Date().toISOString() 
      };
    });
  };

  // Parse string collaborators into array for UI
  const parseCollaborators = (collabString) => {
    if (typeof collabString !== 'string' || !collabString) return [];
    return collabString.split(",").filter(Boolean).map(name => name.trim());
  };

  // Load posts from Appwrite
  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const res = await databases.listDocuments(DATABASE_ID, POSTS_COLLECTION_ID);
        const currentUserEmail = currentUser?.email;
        
        const safePosts = res.documents.map((p) => ({
          ...p,
          comments: parseComments(p.comments || ""),
          collaborators: parseCollaborators(p.collaborators || ""),
          image: p.image || "",
          upvotes: p.upvotes || 0,
          // Use localStorage to determine if user has upvoted
          hasUpvoted: currentUserEmail ? hasUserUpvoted(p.$id, currentUserEmail) : false,
          status: p.status || "pending",
          pdf_generated: p.pdf_generated || false,
          authorities_sent: p.authorities_sent || 0,
          total_authorities: p.total_authorities || 0,
        }));
        setPosts(safePosts);
      } catch (err) {
        console.error("❌ Failed to fetch posts:", err);
        if (process.env.NODE_ENV === 'production') {
          alert("Failed to load posts. Please try again.");
        }
      }
    };
    
    if (currentUser !== null) {
      fetchPosts();
    }
  }, [currentUser]);

  // Enhanced Groq call using environment variable
  const callGroqRewrite = async (text) => {
    try {
      const GROQ_KEY = process.env.REACT_APP_GROQ_API_KEY;
      
      if (!GROQ_KEY) {
        console.warn("⚠️ GROQ_API_KEY not configured, using fallback authorities");
        return {
          rewritten: `Formal complaint regarding ${newPost.title}. The issue described involves ${newPost.category.toLowerCase()} and requires immediate attention from relevant authorities. The problem is located at ${newPost.location} and affects public welfare and safety. Detailed investigation and remedial action is requested under applicable laws.`,
          location: newPost.location || "",
          authorities: [
            {
              name: "Local Municipal Authority",
              twitter: "@municipality",
              email: "complaints@municipal.gov.in",
              address: `${newPost.location || "City Municipal Corporation Office"}`
            }
          ]
        };
      }

      const payload = {
        model: "llama-3.3-70b-versatile",
        messages: [
          {
            role: "system",
            content: `You are a legal-drafting assistant. Using the inputs {DATE},${newPost.author},${newPost.location},${newPost.email || 'N/A'},${newPost.category},${newPost.title},${newPost.incidentDate || 'Recent'},${newPost.location},${text},${newPost.image ? 'Photographic evidence attached' : 'No visual evidence'},${getLegalProvisions(newPost.category)},${newPost.relief || 'Immediate action and investigation'}, generate one formal legal complaint document in English with headings: To, Subject, COMPLAINANT, BRIEF FACTS, PARTIES, EVIDENCE ATTACHED, LEGAL PROVISIONS, CONSEQUENCES, RELIEF SOUGHT, DECLARATION, signature block, and enclosures. Output only the complaint text.

Base the authorities on common ones for categories like Government Services (e.g., Municipal Corporation, @municipality), Brands (e.g., Consumer Forum, @brandhandle). If unsure, suggest generic like @localgov.

For the JSON response, ensure you return:
{
  "rewritten": "The formal complaint text",
  "location": "Extracted location from text",
  "authorities": [
    {
      "name": "Authority Name",
      "twitter": "@handle",
      "email": "official@email.com",
      "address": "Office Address"
    }
  ]
}`,
          },
          { 
            role: "user", 
            content: `Category: ${newPost.category}\nTitle: ${newPost.title}\nLocation: ${newPost.location}\nDescription: ${text}` 
          },
        ],
        max_tokens: 800,
        temperature: 0.2,
      };

      const res = await fetch("https://api.groq.com/openai/v1/chat/completions", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${GROQ_KEY}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const txt = await res.text();
        console.error("Groq error:", res.status, txt);
        throw new Error("Groq API error - using fallback template");
      }

      const data = await res.json();
      let response = data?.choices?.[0]?.message?.content || "";

      // Clean response and attempt JSON parsing
      response = response.replace(/```json|```/g, "").trim();

      let parsedResponse;
      try {
        const jsonStart = response.indexOf('{');
        const jsonEnd = response.lastIndexOf('}') + 1;
        if (jsonStart !== -1 && jsonEnd !== -1) {
          const jsonString = response.substring(jsonStart, jsonEnd);
          parsedResponse = JSON.parse(jsonString);
        }
      } catch (jsonErr) {
        console.warn("JSON parsing failed, using raw response as fallback:", jsonErr);
      }

      // Fallback authorities based on category
      const fallbackAuthorities = [
        {
          name: newPost.category === "Government Services" ? "Municipal Corporation" :
                newPost.category === "Brands & Products" ? "District Consumer Forum" :
                newPost.category === "Environment" ? "State Pollution Control Board" :
                "Local Government Authority",
          twitter: `@${newPost.category.toLowerCase().replace(/ & /g, '').replace(/ /g, '')}gov`,
          email: `complaints@${newPost.category.toLowerCase().replace(/ & /g, '').replace(/ /g, '')}.gov.in`,
          address: `${newPost.location}, India`
        }
      ];

      return {
        rewritten: parsedResponse?.rewritten || response || text,
        location: parsedResponse?.location || newPost.location || "",
        authorities: parsedResponse?.authorities?.length > 0 ? parsedResponse.authorities : fallbackAuthorities
      };

    } catch (e) {
      console.error("callGroqRewrite error:", e);
      
      return {
        rewritten: `To: The Competent Authority\n\nSubject: Formal Complaint Regarding ${newPost.title}\n\nRespected Sir/Madam,\n\nI, ${newPost.author}, resident of ${newPost.location}, do hereby lodge this formal complaint concerning the following matter:\n\nBRIEF FACTS:\nThe issue involves ${newPost.category.toLowerCase()} and has been causing significant inconvenience to the public. The problem is located at ${newPost.location} and requires immediate attention.\n\nPARTIES INVOLVED:\nThe concerned authorities responsible for this matter.\n\nEVIDENCE ATTACHED:\n${newPost.image ? 'Photographic evidence' : 'Detailed description'}\n\nLEGAL PROVISIONS:\n${getLegalProvisions(newPost.category).substring(0, 200)}\n\nRELIEF SOUGHT:\nImmediate investigation and remedial action.\n\nDECLARATION:\nThe contents are true to the best of my knowledge.\n\n${newPost.author}\n${newPost.location}\nDate: ${new Date().toLocaleDateString('en-IN')}`,
        location: newPost.location || "",
        authorities: [
          {
            name: "Local Municipal Authority",
            twitter: "@municipality",
            email: "complaints@municipal.gov.in",
            address: `${newPost.location || "City Municipal Office"}`
          }
        ]
      };
    }
  };

  // Dynamic legal provisions by category
  const getLegalProvisions = (category) => {
    const provisions = {
      "Government Services": "Section 133 CrPC (Public Nuisance), Municipal Corporation Act, Right to Services Act 2015, Consumer Protection Act 1986",
      "Brands & Products": "Consumer Protection Act 2019, Sale of Goods Act 1930, Legal Metrology Act 2009, Drugs and Cosmetics Act 1940",
      "Social Issues": "Article 21 Constitution (Right to Life), Protection of Civil Rights Act 1955, POCSO Act 2012, Domestic Violence Act 2005",
      "Infrastructure": "National Highways Act 1956, Indian Roads Congress Specifications, Disaster Management Act 2005, Local Municipal Laws",
      "Environment": "Environment Protection Act 1986, Water Act 1974, Air Act 1981, Forest Conservation Act 1980, Wildlife Protection Act 1972",
      "Healthcare": "Clinical Establishments Act 2010, Indian Medical Council Regulations 2002, Epidemic Diseases Act 1897, Mental Healthcare Act 2017",
      "Education": "RTE Act 2009, UGC Act 1956, AICTE Act 1987, National Education Policy 2020, Protection of Children Act",
      "Other": "Relevant Central/State Acts, Municipal Regulations, Constitutional Provisions, Local Government Rules"
    };
    return provisions[category] || provisions["Other"];
  };

  // Generalized backend call for tweet, PDF gen, email
  const postToBackend = async (action, payload) => {
    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 30000);

      const res = await fetch("https://arush1234sharma-querio-backend.hf.space/process", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action, ...payload }),
        signal: controller.signal
      });

      clearTimeout(timeoutId);

      if (!res.ok) {
        const errorText = await res.text();
        throw new Error(`Backend ${action} failed: ${res.status} - ${errorText}`);
      }
      
      return await res.json();
    } catch (err) {
      if (err.name === 'AbortError') {
        return { ok: false, error: "Request timeout - please try again" };
      }
      console.error(`${action} error:`, err);
      return { ok: false, error: err.message || "Network error" };
    }
  };

  // Handle image upload with preview
  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.type.startsWith('image/')) {
      alert("Please select a valid image file (JPG, PNG, GIF)");
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      alert("Image size must be less than 5MB");
      return;
    }

    try {
      const previewUrl = URL.createObjectURL(file);
      setPreview(previewUrl);

      const uploaded = await storage.createFile(STORAGE_BUCKET_ID, ID.unique(), file);
      console.log("✅ Image uploaded:", uploaded.$id);

      const publicUrl = storage.getFileView(STORAGE_BUCKET_ID, uploaded.$id);
      console.log("🖼️ Public URL:", publicUrl);

      setNewPost(prev => ({ ...prev, image: publicUrl.toString() }));
      
      if (preview) {
        URL.revokeObjectURL(preview);
      }
    } catch (err) {
      console.error("❌ Image upload failed:", err);
      alert("Failed to upload image. Please try again.");
      if (preview) {
        URL.revokeObjectURL(preview);
        setPreview(null);
      }
    }
  };

  // Handle upvote and persist to Appwrite (UPDATED - without upvotedBy)
  const handleUpvote = async (postId) => {
    try {
      // Get current user from auth
      if (!currentUser || !currentUser.email) {
        alert("Please sign in to upvote posts");
        return;
      }

      const userEmail = currentUser.email;
      const post = posts.find(p => p.$id === postId);
      if (!post) return;

      // Check if user already upvoted using localStorage only
      if (hasUserUpvoted(postId, userEmail)) {
        alert("You have already upvoted this post!");
        return;
      }

      const currentUpvotes = post.upvotes || 0;
      const newUpvotes = currentUpvotes + 1;

      // Update in Appwrite - ONLY update upvotes, not upvotedBy
      await databases.updateDocument(DATABASE_ID, POSTS_COLLECTION_ID, postId, {
        upvotes: newUpvotes,
      });

      // Mark as upvoted in local storage
      markPostAsUpvoted(postId, userEmail);

      // Update local state
      setPosts(prev => 
        prev.map(p =>
          p.$id === postId
            ? { 
                ...p, 
                upvotes: newUpvotes, 
                hasUpvoted: true,
              }
            : p
        )
      );

      // Show success feedback
      showUpvoteFeedback(post.title);
      console.log(`✅ ${userEmail} upvoted post ${postId}`);
    } catch (err) {
      console.error("❌ Upvote failed:", err);
      alert("Failed to update upvote. Please try again.");
    }
  };

  // Handle comment addition and persist to Appwrite
  const handleAddComment = async (postId) => {
    if (!commentText.trim() || isSubmitting) return;

    const newComment = {
      text: commentText.trim().slice(0, 500),
      author: newPost.author || "Anonymous User",
      createdAt: new Date().toISOString(),
    };

    try {
      const post = posts.find(p => p.$id === postId);
      if (!post) return;

      const currentComments = parseComments(post.comments);
      const updatedComments = [...currentComments, newComment];
      
      const limitedComments = updatedComments.slice(-50);
      const commentString = limitedComments
        .map(c => `${c.text}|${c.author}|${c.createdAt}`)
        .join(";");

      await databases.updateDocument(DATABASE_ID, POSTS_COLLECTION_ID, postId, {
        comments: commentString,
      });

      setPosts(prev =>
        prev.map(p =>
          p.$id === postId
            ? { ...p, comments: parseComments(commentString) }
            : p
        )
      );
      
      setCommentText("");
      console.log("✅ Comment added successfully");
    } catch (err) {
      console.error("❌ Comment failed:", err);
      alert("Failed to add comment. Please try again.");
    }
  };

  // Handle collaborator addition and persist to Appwrite
  const handleAddCollaborator = async (postId) => {
    if (!collabName.trim() || isSubmitting) return;

    try {
      const post = posts.find(p => p.$id === postId);
      if (!post) return;

      const currentCollaborators = parseCollaborators(post.collaborators);
      const cleanName = collabName.trim();
      
      if (currentCollaborators.includes(cleanName)) {
        alert("You're already a collaborator on this issue!");
        return;
      }

      const updatedCollaborators = [...currentCollaborators, cleanName];
      const limitedCollaborators = updatedCollaborators.slice(0, 30);
      const collabString = limitedCollaborators.join(",");

      await databases.updateDocument(DATABASE_ID, POSTS_COLLECTION_ID, postId, {
        collaborators: collabString,
      });

      setPosts(prev =>
        prev.map(p =>
          p.$id === postId
            ? { ...p, collaborators: parseCollaborators(collabString) }
            : p
        )
      );
      
      setCollabName("");
      console.log(`✅ ${cleanName} added as collaborator`);
    } catch (err) {
      console.error("❌ Collaborator addition failed:", err);
      alert("Failed to add collaborator. Please try again.");
    }
  };

  // Create post with tweet, PDF, email flow (UPDATED - without upvotedBy)
  const handleCreatePost = async () => {
    if (!newPost.title?.trim()) {
      alert("Please enter a title for your issue");
      return;
    }
    
    if (!newPost.description?.trim()) {
      alert("Please describe your issue in detail");
      return;
    }
    
    if (!newPost.author?.trim()) {
      alert("Please enter your name");
      return;
    }
    
    if (!newPost.location?.trim()) {
      alert("Please specify the location of the issue");
      return;
    }

    if (newPost.description.length < 20) {
      alert("Please provide more details about your issue (minimum 20 characters)");
      return;
    }

    setIsSubmitting(true);
    setOriginalButtonText("Processing...");
    
    let tweetSuccess = false;
    let tweetId = null;
    let pdfSuccess = false;
    let emailSuccessCount = 0;
    let emailTotal = 0;

    try {
      console.log("🤖 Calling Groq API for legal formatting...");
      const groqRes = await callGroqRewrite(newPost.description);
      const { rewritten, location: extractedLocation, authorities } = groqRes;
      
      const finalLocation = extractedLocation || newPost.location;
      console.log("📄 Groq response:", {
        rewritten: rewritten.substring(0, 100) + "...",
        location: finalLocation,
        authorities: authorities.map(a => a.name).join(", ")
      });

      const tweetTags = authorities
        .slice(0, 3)
        .map(auth => auth.twitter ? `@${auth.twitter.replace('@', '')}` : '')
        .filter(Boolean)
        .join(' ');

      const tweetText = `${newPost.title}

"${rewritten.substring(0, 150)}..."

📍 ${finalLocation}
${newPost.category}

#CitizenComplaint #PublicIssue ${tweetTags}`;

      console.log("🐦 Tweet content prepared:", tweetText.length, "characters");

      try {
        const tweetRes = await postToBackend("tweet", { 
          text: tweetText,
          image_url: newPost.image || null,
          category: newPost.category
        });
        
        if (tweetRes.ok) {
          tweetSuccess = true;
          tweetId = tweetRes.tweet_id || tweetRes.tweet_url || null;
          console.log("✅ Tweet posted:", tweetId);
        } else {
          console.warn("Tweet failed (non-blocking):", tweetRes.error);
        }
      } catch (tweetErr) {
        console.warn("Tweet error (continuing anyway):", tweetErr.message);
      }

      console.log("📋 Generating legal PDF...");
      
      const currentDate = new Date().toLocaleDateString('en-IN', { 
        day: '2-digit', month: 'long', year: 'numeric' 
      });

      const formattedAuthorities = authorities.map(auth => 
        `${auth.name}\n${auth.address || finalLocation}\n${auth.email ? `Email: ${auth.email}` : ''}`
      ).join('\n\n');

      const legalPrompt = `Generate a formal legal complaint document with the following EXACT structure and formatting:

[TOP RIGHT CORNER]
Date: ${currentDate}

[LEFT ALIGNED]
To,
${formattedAuthorities}

Subject: Formal Complaint Regarding ${newPost.title}

Respected Sir/Madam,

[BODY - Use formal legal language]
I, ${newPost.author}, resident of ${finalLocation}, hereby lodge this formal complaint regarding the following matter:

1. BACKGROUND AND FACTS:
${rewritten}

2. NATURE OF GRIEVANCE:
The issue constitutes a violation of public welfare standards under ${newPost.category}. This involves negligence in [specific service/infrastructure] leading to public inconvenience and safety concerns.

3. IMPACT AND CONSEQUENCES:
The matter affects community safety, public health, and essential services. Continued inaction may result in escalation of the problem and legal liabilities.

4. EVIDENCE:
${newPost.image ? 'Photographic evidence attached showing the exact issue location and condition.' : 'Detailed observations and community impact documentation.'}

5. LEGAL PROVISIONS:
${getLegalProvisions(newPost.category)}

6. RELIEF SOUGHT:
I respectfully request the following actions:
a) Immediate investigation within 7 days
b) Remedial action within 15 days  
c) Regular status updates via email/SMS
d) Compensation for damages if applicable
e) Preventive measures to avoid recurrence

7. CONCLUSION:
I trust your office will treat this matter with utmost urgency. I remain available for clarification or personal hearing as required.

Thanking you in anticipation of prompt action.

Yours faithfully,

${newPost.author}
${finalLocation}
${newPost.phone ? `Phone: ${newPost.phone}` : ''}
${newPost.email ? `Email: ${newPost.email}` : ''}

[FOOTER]
Enclosures:
1. ${newPost.image ? 'Photographic evidence' : 'Issue description'}
2. Supporting documents (if applicable)
3. Copy for records

Note: Please acknowledge receipt within 3 working days and provide reference number for tracking.`;

      const pdfRes = await postToBackend("generate_pdf", {
        title: `Legal-Complaint-${newPost.title.replace(/[^a-zA-Z0-9]/g, '-')}-${Date.now()}`,
        content: legalPrompt,
        authorities: authorities,
        category: newPost.category,
        complainant: newPost.author,
        location: finalLocation,
        has_image: !!newPost.image,
        format: 'A4'
      });

      console.log("PDF Response:", pdfRes);

      if (pdfRes.ok && pdfRes.pdf_base64) {
        pdfSuccess = true;
        
        setGeneratedPDF({
          base64: pdfRes.pdf_base64,
          filename: pdfRes.filename || `Legal-Complaint-${newPost.title.replace(/[^a-zA-Z0-9]/g, '-')}.pdf`
        });

        const link = document.createElement('a');
        link.href = `data:application/pdf;base64,${pdfRes.pdf_base64}`;
        link.download = pdfRes.filename || `Legal-Complaint-${Date.now()}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        console.log("✅ PDF downloaded:", pdfRes.filename);
      } else {
        console.warn("PDF generation failed:", pdfRes?.error);
      }

      if (pdfSuccess && pdfRes.pdf_base64 && authorities.length > 0) {
        console.log("📧 Emailing authorities...");
        emailTotal = authorities.length;

        for (const authority of authorities) {
          if (!authority.email || !authority.email.includes('@')) {
            console.warn(`Skipping ${authority.name}: No valid email`);
            continue;
          }

          try {
            const emailRes = await postToBackend("send_email", {
              to: authority.email,
              subject: `Formal Legal Complaint: ${newPost.title}`,
              body: `Dear ${authority.name},

A formal legal complaint has been filed against your department/organization regarding:

📋 Title: ${newPost.title}
📍 Location: ${finalLocation}  
👤 Complainant: ${newPost.author}
📂 Category: ${newPost.category}

Key Issues:
${rewritten.substring(0, 300)}...

Legal Basis: ${getLegalProvisions(newPost.category).substring(0, 150)}

Please find the complete formal complaint attached.

This matter requires your immediate attention and action within 15 days as per applicable laws.

For tracking: Complaint ID Q${Date.now().toString().slice(-6)}

Regards,
Querio Platform
Citizen Grievance Portal`,
              attachment: pdfRes.pdf_base64,
              filename: pdfRes.filename,
              category: newPost.category,
            });

            if (emailRes.ok) {
              emailSuccessCount++;
              console.log(`✅ Email sent to ${authority.name} (${authority.email})`);
            } else {
              console.warn(`Email failed for ${authority.name}:`, emailRes.error);
            }
          } catch (emailErr) {
            console.error(`Email error for ${authority.name}:`, emailErr);
          }
        }
      }

      console.log(`📧 Emails: ${emailSuccessCount}/${emailTotal} successful`);

      console.log("💾 Saving to database...");
      
      const docData = {
        title: newPost.title,
        description: rewritten.substring(0, 1000),
        category: newPost.category,
        author: newPost.author,
        location: finalLocation,
        phone: newPost.phone || null,
        email: newPost.email || null,
        image: newPost.image || null,
        upvotes: 0,
        comments: "",
        collaborators: "",
        status: "pending",
        pdf_generated: pdfSuccess,
        authorities_sent: emailSuccessCount,
        total_authorities: emailTotal,
        tweet_id: tweetId || null,
      };

      const appwriteRes = await databases.createDocument(
        DATABASE_ID,
        POSTS_COLLECTION_ID,
        ID.unique(),
        docData
      );

      console.log("✅ Saved to Appwrite:", appwriteRes.$id);

      const newPostObj = {
        ...appwriteRes,
        comments: [],
        collaborators: [],
        hasUpvoted: false,
      };

      setPosts([newPostObj, ...posts]);

      setShowNewPost(false);
      setNewPost({
        title: "", description: "", category: "Government Services",
        author: "", location: "", image: "", phone: "", email: ""
      });
      setPreview(null);
      setGeneratedPDF(null);
      setIsSubmitting(false);
      setOriginalButtonText("Post Issue");

      const successParts = [
        "✅ Your complaint has been successfully processed!",
        "",
        `📝 Reference ID: Q${Date.now().toString().slice(-6)}`,
        `📱 Tweeted: ${tweetSuccess ? '✅ Yes' : '⚠️ Skipped'}`,
        `📄 Legal PDF: ${pdfSuccess ? '✅ Generated & Downloaded' : '⚠️ Failed'}`,
        `📧 Authorities: ${emailSuccessCount}/${emailTotal} notified`,
        `💾 Saved to dashboard for tracking`
      ];

      alert(successParts.join('\n'));

    } catch (err) {
      console.error("❌ Post creation error:", err);
      
      setIsSubmitting(false);
      setOriginalButtonText("Post Issue");
      
      alert(`Error processing complaint: ${err.message}\n\nPlease check your connection and try again.`);
    }
  };

  const filteredPosts = filterCategory === "All" ? posts : posts.filter(p => p.category === filterCategory);

  return (
    <div className="min-h-screen bg-gray-900">
      <div className="relative min-h-screen overflow-hidden">
        <div className="lumin-landing-bg"></div>
        
        <header className="glass-effect shadow-md relative z-10">
          <div className="max-w-7xl mx-auto px-4 py-6">
            <div className="flex items-center justify-between">
              <div className="text-white">
                <h1 className="text-2xl font-bold">Querio Platform</h1>
                <p className="text-sm text-indigo-300">AI-Powered Citizen Grievance Portal</p>
                {currentUser && (
                  <p className="text-xs text-green-300 mt-1">
                    Signed in as: {currentUser.email}
                  </p>
                )}
              </div>
              <button
                onClick={() => setShowNewPost(true)}
                disabled={isSubmitting}
                className={`px-6 py-3 rounded-2xl flex items-center gap-2 font-semibold transition-all ${
                  isSubmitting 
                    ? "bg-gray-600 text-gray-300 cursor-not-allowed" 
                    : "bg-indigo-600 hover:bg-indigo-700 text-white button-gradient shadow-lg"
                }`}
              >
                {isSubmitting ? (
                  <>
                    <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                    Processing...
                  </>
                ) : (
                  <>
                    <Plus size={20} />
                    {originalButtonText}
                  </>
                )}
              </button>
            </div>
          </div>
        </header>

        <div className="max-w-7xl mx-auto px-4 py-8 relative z-10">
          <div className="mb-8 glass-effect p-4 rounded-2xl shadow-sm backdrop-blur-sm">
            <div className="flex items-center gap-3 flex-wrap">
              <Filter size={20} className="text-indigo-300" />
              <span className="font-semibold text-white">Filter by Category:</span>
              
              <button
                onClick={() => setFilterCategory("All")}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all m-1 ${
                  filterCategory === "All"
                    ? "bg-indigo-600 text-white shadow-md"
                    : "bg-gray-800/50 text-gray-300 hover:bg-gray-700/50 border border-white/20"
                }`}
              >
                All ({posts.length})
              </button>
              
              {categories.map(cat => {
                const count = posts.filter(p => p.category === cat).length;
                return (
                  <button
                    key={cat}
                    onClick={() => setFilterCategory(cat)}
                    className={`px-4 py-2 rounded-full text-sm font-medium transition-all m-1 ${
                      filterCategory === cat
                        ? "bg-indigo-600 text-white shadow-md"
                        : "bg-gray-800/50 text-gray-300 hover:bg-gray-700/50 border border-white/20"
                    }`}
                  >
                    {cat} ({count})
                  </button>
                );
              })}
            </div>
          </div>

          <div className="grid gap-6">
            {filteredPosts.length > 0 ? filteredPosts.map(post => (
              <div key={post.$id} className="glass-effect rounded-3xl shadow-lg hover:shadow-xl transition-all duration-300 p-6 border border-white/10">
                <div className="flex items-start justify-between mb-4">
                  <div className="flex-1">
                    <div className="flex items-center gap-3 mb-3 flex-wrap">
                      <span className="px-3 py-1 bg-gradient-to-r from-indigo-500 to-purple-600 text-white rounded-full text-sm font-medium">
                        {post.category}
                      </span>
                      
                      <span className="text-indigo-300 text-sm">
                        {post.createdAt ? Math.floor((new Date() - new Date(post.createdAt)) / (1000 * 60 * 60 * 24)) : 0} days ago
                      </span>
                      
                      {post.pdf_generated && (
                        <span className="px-2 py-1 bg-green-500/20 text-green-300 rounded-full text-xs font-medium border border-green-500/30">
                          📄 Legal PDF
                        </span>
                      )}
                      
                      {post.status && (
                        <span className={`px-2 py-1 rounded-full text-xs font-semibold ${
                          post.status === 'pending' ? 'bg-yellow-500/20 text-yellow-300 border-yellow-500/30' :
                          post.status === 'in_progress' ? 'bg-blue-500/20 text-blue-300 border-blue-500/30' :
                          'bg-green-500/20 text-green-300 border-green-500/30'
                        } border`}>
                          {post.status.replace('_', ' ').toUpperCase()}
                        </span>
                      )}
                    </div>

                    <h2 className="text-2xl font-bold text-white mb-3 leading-tight">
                      {post.title}
                    </h2>

                    <p className="text-gray-300 mb-4 leading-relaxed" style={{display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden'}}>
                      {post.description}
                    </p>

                    {post.image && (
                      <div className="mb-4 rounded-xl overflow-hidden border border-white/10">
                        <img
                          src={post.image}
                          alt="Issue evidence"
                          className="w-full h-48 object-cover"
                          onError={(e) => {
                            console.warn("Image load failed:", post.image);
                            e.target.style.display = 'none';
                          }}
                        />
                      </div>
                    )}

                    <div className="space-y-2 mb-4 text-sm">
                      <div className="flex items-center gap-2 text-indigo-400">
                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                        </svg>
                        <span className="font-medium">{post.location}</span>
                      </div>

                      {post.author && (
                        <div className="flex items-center gap-4 text-gray-400">
                          <span className="flex items-center gap-1">
                            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                            </svg>
                            <span>By {post.author}</span>
                          </span>
                          
                          {post.collaborators?.length > 0 && (
                            <span className="flex items-center gap-1">
                              <Users className="w-4 h-4 text-green-400" />
                              <span>{post.collaborators.length} supporters</span>
                            </span>
                          )}
                          
                          {post.authorities_sent > 0 && (
                            <span className="flex items-center gap-1 text-green-400">
                              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                              </svg>
                              <span>{post.authorities_sent} authorities notified</span>
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="flex items-center gap-4 pt-4 border-t border-white/10">
                  <button
                    onClick={() => handleUpvote(post.$id)}
                    disabled={post.hasUpvoted || hasUserUpvoted(post.$id, currentUser?.email)}
                    className={`flex items-center gap-2 px-4 py-2 rounded-xl font-medium transition-all ${
                      post.hasUpvoted || hasUserUpvoted(post.$id, currentUser?.email)
                        ? "bg-gradient-to-r from-indigo-600 to-purple-600 text-white shadow-lg cursor-not-allowed"
                        : "bg-white/10 text-gray-300 hover:bg-white/20 hover:text-white border border-white/20"
                    }`}
                  >
                    <ThumbsUp size={16} />
                    <span>{post.upvotes || 0}</span>
                    {post.hasUpvoted || hasUserUpvoted(post.$id, currentUser?.email) ? " ✅" : ""}
                  </button>

                  <button
                    onClick={() => setSelectedPost(selectedPost === post.$id ? null : post.$id)}
                    className="flex items-center gap-2 px-4 py-2 rounded-xl bg-white/10 text-gray-300 hover:bg-white/20 hover:text-white border border-white/20 transition-all"
                  >
                    <MessageCircle size={16} />
                    <span>{(post.comments || []).length}</span>
                  </button>

                  <button className="flex items-center gap-2 px-4 py-2 rounded-xl bg-white/10 text-gray-300 hover:bg-white/20 hover:text-white border border-white/20 transition-all">
                    <Users size={16} />
                    <span>{(post.collaborators || []).length}</span>
                  </button>

                  {post.tweet_id && (
                    <a
                      href={`https://twitter.com/${post.tweet_id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-2 px-4 py-2 rounded-xl bg-blue-500/20 text-blue-300 hover:bg-blue-500/30 hover:text-blue-200 border border-blue-500/30 transition-all"
                    >
                      🐦 View Tweet
                    </a>
                  )}
                </div>

                {selectedPost === post.$id && (
                  <div className="mt-6 space-y-6 border-t border-white/10 pt-6">
                    <div>
                      <h3 className="font-semibold text-white mb-4 flex items-center gap-2">
                        <MessageCircle size={20} className="text-indigo-400" />
                        Comments ({(post.comments || []).length})
                      </h3>
                      
                      <div className="space-y-3 mb-4 max-h-40 overflow-y-auto">
                        {(post.comments || []).map(comment => (
                          <div key={comment.id} className="bg-white/5 p-3 rounded-xl border border-white/10">
                            <div className="flex items-center gap-2 mb-1">
                              <span className="px-2 py-1 bg-indigo-500/20 text-indigo-300 rounded-full text-xs">
                                {comment.author}
                              </span>
                              <span className="text-xs text-gray-400">
                                {comment.createdAt ? Math.floor((new Date() - new Date(comment.createdAt)) / (1000 * 60)) : 0}m ago
                              </span>
                            </div>
                            <p className="text-gray-300 text-sm">{comment.text}</p>
                          </div>
                        ))}
                      </div>
                      
                      <div className="flex gap-2">
                        <input
                          type="text"
                          value={commentText}
                          onChange={e => setCommentText(e.target.value)}
                          placeholder="Add a comment..."
                          className="flex-1 px-4 py-2 bg-white/10 text-white placeholder-gray-400 border border-white/20 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500"
                          onKeyPress={e => e.key === "Enter" && handleAddComment(post.$id)}
                          maxLength={200}
                          disabled={isSubmitting}
                        />
                        <button
                          onClick={() => handleAddComment(post.$id)}
                          disabled={!commentText.trim() || isSubmitting}
                          className="px-4 py-2 bg-indigo-600 text-white rounded-xl hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center gap-2"
                        >
                          <Send size={16} />
                        </button>
                      </div>
                    </div>

                    <div>
                      <h3 className="font-semibold text-white mb-4 flex items-center gap-2">
                        <Users size={20} className="text-green-400" />
                        Collaborators ({(post.collaborators || []).length})
                      </h3>
                      
                      <div className="flex flex-wrap gap-2 mb-4">
                        {(post.collaborators || []).map((collab, idx) => (
                          <span key={idx} className="px-3 py-1 bg-green-500/20 text-green-300 rounded-full text-sm border border-green-500/30">
                            {collab}
                          </span>
                        ))}
                      </div>
                      
                      <div className="flex gap-2">
                        <input
                          type="text"
                          value={collabName}
                          onChange={e => setCollabName(e.target.value)}
                          placeholder="Your name..."
                          className="flex-1 px-4 py-2 bg-white/10 text-white placeholder-gray-400 border border-white/20 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500"
                          onKeyPress={e => e.key === "Enter" && handleAddCollaborator(post.$id)}
                          maxLength={50}
                          disabled={isSubmitting}
                        />
                        <button
                          onClick={() => handleAddCollaborator(post.$id)}
                          disabled={!collabName.trim() || isSubmitting}
                          className="px-4 py-2 bg-green-600 text-white rounded-xl hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center gap-2"
                        >
                          <Users size={16} />
                          Join
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )) : (
              <div className="col-span-full text-center py-16">
                <div className="text-gray-400 text-xl mb-4">
                  {filterCategory === "All" ? "No issues yet" : `No ${filterCategory.toLowerCase()} issues found`}
                </div>
                <p className="text-gray-500 mb-8 max-w-md mx-auto">
                  Be the first to report a community issue. Your complaint will be professionally formatted and sent to the right authorities.
                </p>
                <button
                  onClick={() => setShowNewPost(true)}
                  disabled={isSubmitting}
                  className={`px-8 py-3 rounded-2xl font-semibold transition-all ${
                    isSubmitting
                      ? "bg-gray-600 text-gray-300 cursor-not-allowed"
                      : "bg-gradient-to-r from-indigo-600 to-purple-600 text-white hover:shadow-xl transform hover:-translate-y-1"
                  } flex items-center gap-2 mx-auto`}
                >
                  <Plus size={20} />
                  {isSubmitting ? "Processing..." : "Report First Issue"}
                </button>
              </div>
            )}
          </div>
        </div>

        {showNewPost && (
          <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 z-50">
            <div className="bg-white/95 backdrop-blur-xl rounded-3xl max-w-4xl w-full max-h-[95vh] overflow-hidden shadow-2xl border border-white/20">
              <div className="sticky top-0 bg-white z-20 border-b border-gray-200 px-6 py-4">
                <div className="flex items-center justify-between">
                  <div>
                    <h2 className="text-2xl font-bold text-gray-900">File New Complaint</h2>
                    <p className="text-gray-600 text-sm mt-1">Your submission will be automatically formatted into a professional legal document</p>
                  </div>
                  <button
                    onClick={() => {
                      setShowNewPost(false);
                      setNewPost({title:"",description:"",category:"Government Services",author:"",location:"",image:"",phone:"",email:""});
                      setPreview(null);
                    }}
                    className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-xl transition-colors"
                  >
                    <X size={24} />
                  </button>
                </div>
              </div>

              <div className="p-6 overflow-y-auto max-h-[calc(95vh-8rem)]">
                <div className="grid md:grid-cols-2 gap-6">
                  <div className="space-y-4">
                    <div className="md:col-span-2">
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Your Full Name <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        value={newPost.author}
                        onChange={e => setNewPost({...newPost, author: e.target.value})}
                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent text-gray-900"
                        placeholder="Enter your full name"
                        required
                        disabled={isSubmitting}
                      />
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Phone</label>
                        <input
                          type="tel"
                          value={newPost.phone}
                          onChange={e => setNewPost({...newPost, phone: e.target.value})}
                          className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent text-gray-900"
                          placeholder="+91 98765 43210"
                          disabled={isSubmitting}
                        />
                      </div>
                      
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
                        <input
                          type="email"
                          value={newPost.email}
                          onChange={e => setNewPost({...newPost, email: e.target.value})}
                          className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent text-gray-900"
                          placeholder="your.email@example.com"
                          disabled={isSubmitting}
                        />
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Exact Location <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        value={newPost.location}
                        onChange={e => setNewPost({...newPost, location: e.target.value})}
                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent text-gray-900"
                        placeholder="House #123, Street Name, Area, City - PINCODE"
                        required
                        disabled={isSubmitting}
                      />
                      <p className="text-xs text-gray-500 mt-1">Be as specific as possible for accurate authority routing</p>
                    </div>
                  </div>

                  <div className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Category <span className="text-red-500">*</span>
                      </label>
                      <select
                        value={newPost.category}
                        onChange={e => setNewPost({...newPost, category: e.target.value})}
                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent text-gray-900"
                        disabled={isSubmitting}
                      >
                        {categories.map(cat => (
                          <option key={cat} value={cat}>{cat}</option>
                        ))}
                      </select>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Issue Title <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        value={newPost.title}
                        onChange={e => setNewPost({...newPost, title: e.target.value})}
                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent text-gray-900"
                        placeholder="Clear title describing the problem"
                        required
                        disabled={isSubmitting}
                      />
                    </div>

                    <div className="md:col-span-2">
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Description <span className="text-red-500">*</span>
                      </label>
                      <textarea
                        value={newPost.description}
                        onChange={e => setNewPost({...newPost, description: e.target.value})}
                        rows={6}
                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent resize-vertical min-h-[120px] text-gray-900"
                        placeholder="Describe the issue in detail: When it started, who is responsible, how it affects you and others, what you've tried..."
                        required
                        disabled={isSubmitting}
                      />
                      <div className="mt-2 p-3 bg-blue-50 border border-blue-200 rounded-xl">
                        <p className="text-sm text-blue-800 mb-2">
                          <strong>AI Processing:</strong> Our system will automatically:
                        </p>
                        <ul className="text-xs text-blue-700 space-y-1 list-disc list-inside">
                          <li>Convert your text to formal legal language</li>
                          <li>Identify responsible authorities</li>
                          <li>Add relevant legal provisions</li>
                          <li>Generate professional PDF complaint</li>
                          <li>Email authorities with tracking</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mt-6">
                  <label className="block text-sm font-medium text-gray-700 mb-3">
                    📷 Upload Evidence (Photos help authorities understand the issue)
                  </label>
                  <div className="border-2 border-dashed border-gray-300 rounded-2xl p-8 text-center hover:border-indigo-400 transition-colors cursor-pointer">
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleImageUpload}
                      className="hidden"
                      id="file-upload"
                      disabled={isSubmitting}
                    />
                    <label htmlFor="file-upload" className="cursor-pointer">
                      <div className="space-y-2">
                        {preview ? (
                          <>
                            <img src={preview} alt="Preview" className="mx-auto max-h-32 rounded-xl object-cover" />
                            <p className="text-sm font-medium text-gray-700">Image selected ✓</p>
                            <button
                              type="button"
                              onClick={(e) => {
                                e.preventDefault();
                                setPreview(null);
                                setNewPost(prev => ({...prev, image: ""}));
                                document.getElementById('file-upload').value = '';
                              }}
                              className="text-xs text-red-500 hover:text-red-700"
                            >
                              Remove
                            </button>
                          </>
                        ) : (
                          <>
                            <div className="w-12 h-12 mx-auto mb-3 bg-gray-100 rounded-xl flex items-center justify-center">
                              <svg className="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                              </svg>
                            </div>
                            <p className="text-lg font-medium text-gray-900 mb-1">Upload Photo Evidence</p>
                            <p className="text-sm text-gray-500">JPG, PNG up to 5MB - Multiple photos help</p>
                          </>
                        )}
                      </div>
                    </label>
                  </div>
                </div>

                <div className="flex gap-4 mt-8 pt-6 border-t border-gray-200">
                  <button
                    type="button"
                    onClick={() => {
                      setShowNewPost(false);
                      setNewPost({title:"",description:"",category:"Government Services",author:"",location:"",image:"",phone:"",email:""});
                      setPreview(null);
                    }}
                    disabled={isSubmitting}
                    className="flex-1 px-6 py-3 border border-gray-300 rounded-xl text-gray-700 font-medium hover:bg-gray-50 transition-colors disabled:opacity-50"
                  >
                    Cancel
                  </button>
                  
                  <button
                    type="button"
                    onClick={handleCreatePost}
                    disabled={isSubmitting}
                    className={`flex-1 px-6 py-3 rounded-xl font-semibold shadow-lg transition-all flex items-center justify-center gap-2 ${
                      isSubmitting
                        ? "bg-gray-400 text-gray-200 cursor-not-allowed"
                        : "bg-gradient-to-r from-indigo-600 to-purple-600 text-white hover:shadow-xl hover:-translate-y-0.5"
                    }`}
                  >
                    {isSubmitting ? (
                      <>
                        <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                        Processing with AI...
                      </>
                    ) : (
                      <>
                        <Send size={18} />
                        Submit Legal Complaint
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
